/* import __COLOCATED_TEMPLATE__ from './tap-tile-grid.hbs'; */
import Component from "@ember/component";

export default Component.extend({
  classNames: ["tap-tile-grid"],
  activeTile: null,
});
